'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = require('fastdom');

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = require('./Aria');

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage tablist elements
 *
 * @param {Object} config - Config options for AriaTablist
 * @param {HTMLElement} config.tablist - The tab elements' parent element
 * @param {NodeList} config.panels - A list of panel elements; each panel should have a corresponding tab element in config.tabs
 * @param {MediaQueryList} config.breakpoint - An optional breakpoint definition to be used to init and/or destroy the tablist
 *
 * E.g.:
 * const tablist = new AriaTablist({
 *   tablist: tabsWrapper,
 *   panels: panelElements,
 *   breakpoint: mediaQuery
 * });
 */
var AriaTablist = function (_Aria) {
  _inherits(AriaTablist, _Aria);

  function AriaTablist(config) {
    _classCallCheck(this, AriaTablist);

    var _this = _possibleConstructorReturn(this, (AriaTablist.__proto__ || Object.getPrototypeOf(AriaTablist)).call(this));

    _this.tablist = config.tablist;
    _this.panels = config.panels;
    _this.breakpoint = config.breakpoint;

    _this.index = 0;

    _this.key = {
      arrows: /37|39|40/, // left, right, or down
      arrLeftRight: /37|39/,
      arrLeft: 37,
      arrRight: 39,
      arrDown: 40
    };

    _this.tabs = [];
    _this.panels = Array.prototype.slice.call(_this.panels);

    Array.prototype.forEach.call(_this.tablist.children, function (child) {
      if ('LI' === child.nodeName) {
        child.setAttribute('role', 'presentation');
        var childAnchor = child.querySelector('a[href]');
        _this.tabs.push(childAnchor);
      } else {
        _this.tabs.push(child);
      }
    });

    // Bind class methods
    _this.shiftTabKeyDown = _this.shiftTabKeyDown.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.arrowKeyDown = _this.arrowKeyDown.bind(_this);
    _this.tabKeyDown = _this.tabKeyDown.bind(_this);
    _this.ariaSwitchTab = _this.ariaSwitchTab.bind(_this);
    _this._updateTabs = _this._updateTabs.bind(_this);
    _this.updateTabs = _this.updateTabs.bind(_this);
    _this.handleBreakpoint = _this.handleBreakpoint.bind(_this);
    _this.tearDown = _this.tearDown.bind(_this);

    _Aria3.default.eventPolyfill();

    if (undefined === _this.breakpoint || 'object' !== _typeof(_this.breakpoint)) {
      _this.init();
    } else {
      _this.handleBreakpoint();
      _this.breakpoint.addListener(_this.handleBreakpoint);
    }
    return _this;
  }

  /**
   * Add necessary attributes and event listeners; collect interactive elements.
   */


  _createClass(AriaTablist, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.tablist.setAttribute('role', 'tablist');

      // role=tab, aria-selected
      this.tabs.forEach(function (tab, index) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', '' + (_this2.index === index));
        if (_this2.index === index) {
          tab.setAttribute('tabindex', '0');
        } else {
          tab.setAttribute('tabindex', '-1');
        }

        tab.addEventListener('click', _this2.ariaSwitchTab);
        tab.addEventListener('keydown', _this2.keyDownHandler);
      });

      // role=tabpanel, aria-labelledby, aria-hidden
      this.panels.forEach(function (panel, index) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', '' + (_this2.index !== index));
      });

      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();

      this.panels[this.index].addEventListener('keydown', this.shiftTabKeyDown);

      var tabInit = null;
      var detail = { activePanel: this.panels[this.index] };
      tabInit = _Aria3.default.createAriaEvent('tabinit', detail);
      this.tablist.dispatchEvent(tabInit);
    }

    /**
     * TAB from the active panel's first focusable element back to the active tab.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'shiftTabKeyDown',
    value: function shiftTabKeyDown(event) {
      if (event.keyCode === this.tabKey && event.shiftKey) {
        var focusIndex = this.interactiveChildElements.indexOf(document.activeElement);

        if (0 === focusIndex) {
          var currentPanel = this.panels.filter(function (panel) {
            return 'false' === panel.getAttribute('aria-hidden');
          });
          var panelIndex = this.panels.indexOf(currentPanel[0]);

          event.preventDefault();
          this.tabs[panelIndex].focus();
        }
      }
    }

    /**
     * Handle tablist key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (event.keyCode === this.tabKey && !event.shiftKey) {
        this.tabKeyDown(event);
      } else if (this.key.arrows.test(event.keyCode)) {
        this.arrowKeyDown(event);
      }
    }

    /**
     * Move focus from active tab to active panel's first child.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'tabKeyDown',
    value: function tabKeyDown(event) {
      if (this.interactiveChildElements.length) {
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }

    /**
     * Navigate through tablist with arrow keys.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'arrowKeyDown',
    value: function arrowKeyDown(event) {
      var newIndex = null;
      var deactivate = {};
      var activate = {};

      var currentIndex = this.tabs.indexOf(event.currentTarget);
      deactivate.tab = this.tabs[currentIndex];
      deactivate.panel = this.panels[currentIndex];

      this.panels.forEach(function (panel) {
        panel.removeAttribute('tabindex');
      });

      if (this.key.arrLeftRight.test(event.keyCode)) {
        switch (event.keyCode) {
          case this.key.arrLeft:
            newIndex = currentIndex - 1;
            break;
          case this.key.arrRight:
            newIndex = currentIndex + 1;
            break;
          default:
            newIndex = null;
        }
        event.preventDefault();

        activate.index = newIndex;
        activate.tab = this.tabs[newIndex];
        activate.panel = this.panels[newIndex];

        this.updateTabs(deactivate, activate);
        activate.tab.focus();
      } else if (event.keyCode === this.key.arrDown) {
        event.preventDefault();
        this.panels[currentIndex].setAttribute('tabindex', '-1');
        this.panels[currentIndex].focus();
      }
    }

    /**
     * Externally-exposed tab updater method
     */

  }, {
    key: 'updateTabs',
    value: function updateTabs(deactivate, activate) {
      var _this3 = this;

      _fastdom2.default.mutate(function () {
        _this3._updateTabs(deactivate, activate);
      });
    }

    /**
     * Toggle active panel based on active tab.
     *
     * @param {Object} deactivate
     * @param {HTMLElement} deactivate.tab The tab item to deactivate.
     * @param {HTMLElement} deactivate.panel The panel to deactivate.
     * @param {Object} activate
     * @param {HTMLElement} activate.tab The tab item to activate.
     * @param {HTMLElement} activate.panel The panel to activate.
     * @private
     */

  }, {
    key: '_updateTabs',
    value: function _updateTabs(deactivate, activate) {
      var selected = 'false';
      var hidden = 'true';

      if (null !== deactivate.tab || null !== activate.tab || null !== deactivate.panel || null !== activate.panel) {
        // Update current tab
        deactivate.tab.setAttribute('tabindex', '-1');
        deactivate.tab.setAttribute('aria-selected', selected);
        deactivate.panel.setAttribute('aria-hidden', hidden);

        this.targetElement = deactivate.panel;
        this.collectInteractiveChildren();

        Array.prototype.forEach.call(this.interactiveChildElements, function (focusElement) {
          focusElement.setAttribute('tabindex', '-1');
        });

        deactivate.panel.removeEventListener('keydown', this.shiftTabKeyDown);

        // Update new active tab
        var _ref = [hidden, selected];
        selected = _ref[0];
        hidden = _ref[1];

        activate.tab.setAttribute('tabindex', '0');
        activate.tab.setAttribute('aria-selected', selected);
        activate.panel.setAttribute('aria-hidden', hidden);

        this.targetElement = activate.panel;
        this.collectInteractiveChildren();

        Array.prototype.forEach.call(this.interactiveChildElements, function (element) {
          if ('-1' === element.getAttribute('tabindex')) {
            element.removeAttribute('tabindex');
          }
        });

        this.index = activate.index;

        activate.panel.addEventListener('keydown', this.shiftTabKeyDown);

        var tabChange = null;
        var detail = { activePanel: this.panels[this.index] };
        tabChange = _Aria3.default.createAriaEvent('tabchange', detail);
        this.tablist.dispatchEvent(tabChange);
      }
    }

    /**
     * Collect tab and panel info then toggle tabs/panels.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'ariaSwitchTab',
    value: function ariaSwitchTab(event) {
      var deactivate = {};
      var activate = {};

      event.preventDefault();

      if ('true' !== event.target.getAttribute('aria-selected')) {
        deactivate.tab = this.tablist.querySelector('[aria-selected="true"]');
        var currentTablistIndex = this.tabs.indexOf(deactivate.tab);
        deactivate.panel = this.panels[currentTablistIndex];

        activate.index = this.tabs.indexOf(event.target);
        activate.tab = this.tabs[activate.index];
        activate.panel = this.panels[activate.index];

        this.updateTabs(deactivate, activate);
      }
    }

    /**
     * Destroy the tablist, removing ARIA attributes and event listeners
     */

  }, {
    key: 'tearDown',
    value: function tearDown() {
      var _this4 = this;

      this.tablist.removeAttribute('role');

      this.tabs.forEach(function (tab, index) {
        tab.removeAttribute('role');
        tab.removeAttribute('aria-selected');
        if (_this4.index !== index) {
          tab.removeAttribute('tabindex');
        }

        tab.removeEventListener('click', _this4.ariaSwitchTab);
        tab.removeEventListener('keydown', _this4.keyDownHandler);
      });

      this.panels.forEach(function (panel) {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-hidden');
      });

      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();

      this.panels[this.index].removeEventListener('keydown', this.shiftTabKeyDown);

      var detail = { activePanel: null };
      var tablistTeardown = _Aria3.default.createAriaEvent('tablistTeardown', detail);
      this.tablist.dispatchEvent(tablistTeardown);
    }

    /**
     * Handle breakpoint changes as necessary.
     */

  }, {
    key: 'handleBreakpoint',
    value: function handleBreakpoint() {
      if (this.breakpoint.matches) {
        this.init();
      } else {
        this.tearDown();
      }
    }
  }]);

  return AriaTablist;
}(_Aria3.default);

exports.default = AriaTablist;